'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const $ = require("jquery");
class Common {
    constructor() {
        const self = this;
        // header要素の高さを余分に取る
        this.changeContentTopPadding();
        let timerId;
        const delay = 500;
        $(window).on('resize', () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                self.changeContentTopPadding();
            }, delay);
        });
        // アンカーリンク処理
        $('a[href^="#"], a[href*="/#"], a[href*="#"]').click(function (e) {
            const href = $(this).attr("href");
            // 同一ページ内アンカーリンク
            if (self.isSamePageAnchor(href)) {
                e.preventDefault();
                self.scrollToAnchor(href);
                return;
            }
        });
        // URLがアンカーリンク付きだった時
        // window.addEventListener('load', () => {
        $(window).on('load', () => {
            const url = location.href;
            if (this.isAnchor(url)) {
                $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                setTimeout(() => {
                    self.scrollToAnchor(url);
                }, 300);
                return false;
            }
        });
    }
    changeContentTopPadding() {
        const heightHeader = $('.paramHeader').outerHeight();
        $('.bulletContainer').css({ 'padding-top': heightHeader });
    }
    isAnchor(href) {
        return href.indexOf('#') != -1;
    }
    getAnchorName(href) {
        const index = href.indexOf('#');
        return href.slice(index + 1);
    }
    /**
     * 同ページ（host+pathname一致）のアンカーか
     */
    isSamePageAnchor(href) {
        // hrefが無効ならfalse
        if (!href.includes('#'))
            return false;
        // URLオブジェクトでパース
        let target;
        // 基準URLを現在のlocation.hrefにして相対URLも解決できるようにする
        try {
            target = new URL(href, location.href);
        }
        catch {
            return false;
        }
        // ハッシュが無いならfalse
        if (!target.hash)
            return false;
        // host+pathnameが同じならtrue
        let isSamePage = false;
        if (location.origin === target.origin && location.pathname === target.pathname) {
            isSamePage = true;
        }
        return isSamePage;
    }
    scrollToAnchor(href) {
        const headerHeight = Number($('.paramHeader').outerHeight() ?? 0);
        const anchor = this.getAnchorName(href);
        if (!anchor)
            return;
        const $target = $('#' + anchor);
        const offset = $target.offset();
        if (!offset)
            return;
        const position = offset.top - headerHeight;
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    }
}
exports.Common = Common;
exports.default = Common;
